/**
* @name: left-menu-icon
* @author: weiyong
* @date: 2023-05-14 15:40
* @description：left-menu-icon
* @update: 2023-05-14 15:40
*/
<template>
  <div :class="prefixCls" class="menu-icon h100b">
    <a-button type="primary" @mouseover="mouseOver" @mouseleave="mouseLeave" @click.stop="triggleMenu" class="h100b menu-btn">
      <div class="btn-icon">
        <menu-outlined style="fontSize:16px;" v-if="!menuProps.showMenu"/>
        <close-outlined style="fontSize:16px;"  v-if="menuProps.showMenu"/>
      </div>
    </a-button>

  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "left-menu-icon",
});
</script>

<script lang="ts" setup>
import {MenuOutlined,CloseOutlined} from "@ant-design/icons-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";

const menuStore = useMenuStore();
const {
  menuProps
}:any = storeToRefs(menuStore)

const {prefixCls} = useDesign('left-menu-icon');


const overFlag=ref(true);
/**
 * 鼠标移入
 */
const mouseOver=function (){
  if(unref(overFlag)){
    unref(menuProps).showMenu=true;
  }
}
/**
 * 鼠标移开
 */
const mouseLeave=function (){
  overFlag.value=true;
}

/**
 * 切换点击
 */
const triggleMenu=function (){
  if(unref(menuProps).showMenu===false){
    unref(menuProps).showMenu=true;
  }else{
    unref(menuProps).showMenu=false;
  }
  overFlag.value=false;
}


/**
 * 点击了不是panel里面的元素 则关闭
 * @param event
 */
const clickMenuBody = (event) => {
  const isNotSectionCtl = event.target.closest('.expandMenu') || event.target.closest('.menu-btn');
  if (!isNotSectionCtl) {
    unref(menuProps).showMenu=false;
  }
}


onBeforeUnmount(()=>{
  document.removeEventListener('click',clickMenuBody)
})

onMounted(()=>{
  document.addEventListener('click',clickMenuBody)
})

</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-left-menu-icon';

.@{prefix-cls} {
  .menu-btn{
    border-radius: 0;
  }
  .menu-btn{
    padding:0;
    border-radius: 0 6px 6px 0 !important;
  }
}
</style>
